/* @flow strict */

import * as React from 'react';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { format } from '/client/src/utils/amountTransformation';
import { PayCalculator } from '../../../../utils/buyService';

type FeeTooltipPropType = {
  children: React.Node,
  jsCTooltipRef: React.Ref,
  tax?: *,
  merchant_fee?: *,
  price?: *,
  feeTypeExclude: boolean
};

  const FeeTooltip = ({
  children,
  jsCTooltipRef,
  tax,
  merchant_fee,
  price,
  feeTypeExclude
}: FeeTooltipPropType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const ciaSettingsFee = _.get(context, 'profileCurrent.organization_info.ticket_sparxo_fee_expression', null);

  const [paymentData, setPaymentData] = React.useState([]);

    React.useEffect(() => {
      setPaymentData(PayCalculator(
        _.toNumber(price),
        _.toNumber(price > 0 ? tax : 0),
        _.toNumber(price > 0 ? merchant_fee : 0),
        ciaSettingsFee,
        feeTypeExclude,
      ));
    }, [feeTypeExclude, ciaSettingsFee, merchant_fee, tax, price]);

  return (
    <div className="cssCTooltip" ref={jsCTooltipRef}>
      <CTooltip>
        <CTooltipLabel>
          {children}
        </CTooltipLabel>
        <CTooltipText
          styles={{
            fontSize: '.95rem',
            lineHeight: '22px',
            padding: '10px 2rem'
          }}
        >
          <div
            className='CTooltipText-table-grid'
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridGap: '2px'
            }}
          >
            {paymentData.map(({ key, title, value }): any => (
              <React.Fragment key={key}>
                <span className="col-md-12"> {title}</span>
                <span> {format(currency[context.profileCurrent.currency], value, false, true)}</span>
              </React.Fragment>
            ))}
          </div>
        </CTooltipText>
      </CTooltip>
    </div>
  );
};

export default FeeTooltip;
